var map = {
	"./additionalInfoIcon.svg": 580,
	"./arrowLeftIcon.svg": 581,
	"./arrowMediumTop.svg": 582,
	"./arrowRightIcon.svg": 583,
	"./arrowRightIconSharp.svg": 584,
	"./arrowRightSmallIcon.svg": 585,
	"./arrowScalableIcon.svg": 586,
	"./arrowSelect2.svg": 587,
	"./arrowSelectIcon.svg": 588,
	"./benefit1.svg": 589,
	"./benefit2.svg": 590,
	"./benefit3.svg": 591,
	"./cardsIcon.svg": 592,
	"./copyIcon copy.svg": 593,
	"./copyIcon.svg": 594,
	"./crossIcon.svg": 595,
	"./crossIcon2.svg": 596,
	"./crossIcon3.svg": 597,
	"./crossIconSmall.svg": 598,
	"./crossSmallIcon.svg": 599,
	"./defaultCategoryIcon.svg": 600,
	"./depNumberIcon.svg": 601,
	"./elfCentralIcon.svg": 602,
	"./equalitySign.svg": 603,
	"./errorIcon.svg": 604,
	"./eyeClosedIcon.svg": 605,
	"./eyeOpenIcon.svg": 606,
	"./favoritesIcon.svg": 607,
	"./favoritesLabelIcon.svg": 608,
	"./filterDivider.svg": 609,
	"./filterIcon.svg": 610,
	"./frequencyIcon.svg": 611,
	"./fsAmountIcon.svg": 612,
	"./fullScreenIcon.svg": 613,
	"./gameIcon.svg": 614,
	"./hamburgerIcon.svg": 615,
	"./infoIcon.svg": 616,
	"./infoSymbol.svg": 617,
	"./levelBackground.svg": 618,
	"./levelBackgroundNew.svg": 619,
	"./linkIcon.svg": 620,
	"./lockIcon.svg": 621,
	"./lockSharpIcon.svg": 622,
	"./maxBonusAmountIcon.svg": 623,
	"./maxWinFsIcon.svg": 624,
	"./menu/fortuneIcon.svg": 350,
	"./menu/fortuneIconL.svg": 351,
	"./menu/helpdeskIcon.svg": 352,
	"./menu/helpdeskIconL.svg": 353,
	"./menu/homeIcon.svg": 354,
	"./menu/homeIconLarge.svg": 355,
	"./menu/jackpotIcon.svg": 356,
	"./menu/logo.svg": 357,
	"./menu/logoSmall.svg": 358,
	"./menu/loyaltyIcon.svg": 359,
	"./menu/mobileAppIcon.svg": 360,
	"./menu/profileIcon.svg": 361,
	"./menu/questIcon.svg": 362,
	"./menu/rewardLineupIcon.svg": 363,
	"./menu/searchIcon.svg": 364,
	"./menu/searchIconLarge.svg": 365,
	"./menu/signOutIcon.svg": 366,
	"./menu/star.svg": 367,
	"./menu/tournamentIcon.svg": 368,
	"./menu/tournamentLargeIcon.svg": 369,
	"./menu/vipIcon.svg": 370,
	"./menu/wheelIcon.svg": 371,
	"./menu/wheelIconL.svg": 372,
	"./menu/wheelIconMobile.svg": 373,
	"./menuIcon.svg": 625,
	"./minDepIcon.svg": 626,
	"./noTournamentIcon.svg": 627,
	"./numbers/number-1.svg": 374,
	"./numbers/number-2.svg": 375,
	"./numbers/number-3.svg": 376,
	"./numbers/number-4.svg": 377,
	"./numbers/number-5.svg": 378,
	"./numbers/number-6.svg": 379,
	"./numbers/number-7.svg": 380,
	"./numbers/number-8.svg": 381,
	"./numbers/number-9.svg": 382,
	"./numbers/number-shine-1.svg": 383,
	"./numbers/number-shine-2.svg": 384,
	"./numbers/number-shine-3.svg": 385,
	"./numbers/number-shine-4.svg": 386,
	"./numbers/number-shine-5.svg": 387,
	"./numbers/number-shine-6.svg": 388,
	"./numbers/number-shine-7.svg": 389,
	"./numbers/number-shine-8.svg": 390,
	"./numbers/number-shine-9.svg": 391,
	"./playIcon.svg": 628,
	"./polygon.svg": 629,
	"./preloaderDotsAnimation.svg": 630,
	"./preloaderSpinnerAnimation.svg": 631,
	"./presentIcon.svg": 632,
	"./promoIcon.svg": 633,
	"./recentIcon.svg": 634,
	"./search2Icon.svg": 635,
	"./search3Icon.svg": 636,
	"./sharpTickIcon copy.svg": 637,
	"./sharpTickIcon.svg": 638,
	"./smallInfoSymbol.svg": 639,
	"./smoothArrowIcon.svg": 640,
	"./successIcon.svg": 641,
	"./supportIcon.svg": 642,
	"./tag1Icon.svg": 643,
	"./tag2Icon.svg": 644,
	"./tag3Icon.svg": 645,
	"./tag4Icon.svg": 646,
	"./tickIcon.svg": 647,
	"./unverified.svg": 648,
	"./verified.svg": 649,
	"./wagerIcon.svg": 650,
	"./wagerTimeIcon.svg": 651,
	"./warningIcon.svg": 652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 579;